export const PROJECT_ROLE_OPTIONS = [
  'ARCHITECT',
  'CIVIL_ENGINEER',
  'CIVIL_ENGINEER_EXCAVATION',
  'ELECTRICAL',
  'HEATING_COOLING',
  'VENTILATION_AC',
  'SANITARY',
  'BUILDING_AUTOMATION',
  'SPECIALIST_COORDINATION',
  'LANDSCAPE_ARCHITECT',
] as const

export type ProjectRole = (typeof PROJECT_ROLE_OPTIONS)[number] | 'ENGINEER' | 'HVAC'

export const ROLE_PART_PREFIX: Record<ProjectRole, string> = {
  ARCHITECT: 'architect',
  CIVIL_ENGINEER: 'civil_engineer',
  CIVIL_ENGINEER_EXCAVATION: 'civil_engineer_excavation',
  ELECTRICAL: 'electrical',
  HEATING_COOLING: 'heating_cooling',
  VENTILATION_AC: 'ventilation_ac',
  SANITARY: 'sanitary',
  BUILDING_AUTOMATION: 'building_automation',
  SPECIALIST_COORDINATION: 'specialist_coordination',
  LANDSCAPE_ARCHITECT: 'landscape_architect',
  ENGINEER: 'engineer',
  HVAC: 'hvac',
}

export function migrateProjectRoles(roles: unknown): string[] {
  if (!Array.isArray(roles)) return []

  const next: string[] = []
  for (const role of roles) {
    if (typeof role !== 'string') continue

    if (role === 'ENGINEER') {
      if (!next.includes('CIVIL_ENGINEER')) next.push('CIVIL_ENGINEER')
      continue
    }

    if (role === 'HVAC') {
      if (!next.includes('HEATING_COOLING')) next.push('HEATING_COOLING')
      if (!next.includes('VENTILATION_AC')) next.push('VENTILATION_AC')
      continue
    }

    if (!next.includes(role)) next.push(role)
  }

  return next
}

export function migrateProjectDataParts(project: Record<string, unknown>): Record<string, unknown> {
  const next = { ...project }

  if (next.engineer_setup && !next.civil_engineer_setup) next.civil_engineer_setup = next.engineer_setup
  if (next.engineer_service && !next.civil_engineer_service) next.civil_engineer_service = next.engineer_service

  if (next.hvac_setup) {
    if (!next.heating_cooling_setup) next.heating_cooling_setup = next.hvac_setup
    if (!next.ventilation_ac_setup) next.ventilation_ac_setup = next.hvac_setup
  }

  if (next.hvac_service) {
    if (!next.heating_cooling_service) next.heating_cooling_service = next.hvac_service
    if (!next.ventilation_ac_service) next.ventilation_ac_service = next.hvac_service
  }

  return next
}

export function partForRole(role: string, suffix: 'setup' | 'service'): string | null {
  const prefix = ROLE_PART_PREFIX[role as ProjectRole]
  return prefix ? `${prefix}_${suffix}` : null
}
